import styled from 'styled-components';
import { Container, Typography, Button } from '@/components';
import { LayoutHierarchy, TextStyles } from '@/constants';
import { ButtonVariant, type Breakpoints, ButtonColorKey } from '@/interfaces';
import CheckIcon from '../../../public/images/icons/check.svg';
import { ButtonText } from '@/components/Button/Button.styles';
import { SpinnerText, SpinnerWrapper } from '@/components/Spinner/Spinner.styles';

export const HeaderBannerWrapper = styled.div<{
  breakpoint?: keyof Breakpoints;
}>`
  height: auto;
  min-height: 52px;
  max-height: 104px;
  background-color: #ed7151;
  position: sticky;
  top: 67px;
  z-index: ${LayoutHierarchy.Fourth};

  ${Container} {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme }) => `${theme.spacing[16]} ${theme.spacing[20]}`};
  }

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    top: 72px;
  }

  ${({ theme, breakpoint }) => theme.mediaBreakpointUp[breakpoint ?? 'md']} {
    top: 72px;

    ${Container} {
      padding: ${({ theme }) => `${theme.spacing[8]} ${theme.spacing[20]}`};
    }
  }
`;

export const MobileTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})<{ breakpoint: keyof Breakpoints }>`
  color: ${({ theme }) => theme.colors.highEmphasisWhite};
  margin: 0;
  margin-right: ${({ theme }) => theme.spacing[8]};
  flex: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  -webkit-line-clamp: 3;

  ${({ theme, breakpoint }) => theme.mediaBreakpointUp[breakpoint]} {
    display: none;
  }
`;

// Heading 4
export const DesktopTitle = styled(MobileTitle)<{
  breakpoint: keyof Breakpoints;
}>`
  display: none;

  ${({ theme, breakpoint }) => theme.mediaBreakpointUp[breakpoint]} {
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }
`;

export const MobileButton = styled(Button).attrs({
  variant: ButtonVariant.Outlined,
  color: ButtonColorKey.Transparent,
})<{ hasIcon?: boolean; breakpoint?: keyof Breakpoints }>`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: ${({ theme }) => theme.lineHeight[16]};
  text-transform: uppercase;
  cursor: pointer;
  white-space: pre-wrap;
  max-width: ${({ hasIcon }) => (hasIcon ? 152 : 128)}px;
  min-width: 80px;

  & > span {
    display: flex;
    align-items: center;
    max-height: 32px;
  }

  ${SpinnerWrapper} {
    align-items: center;
  }

  ${SpinnerText}, ${ButtonText} > span:last-child {
    flex: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-word;
    -webkit-line-clamp: 2;
  }

  ${({ theme, breakpoint }) => theme.mediaBreakpointUp[breakpoint ?? 'md']} {
    display: none;
  }
`;

export const DesktopButton = styled(MobileButton)<{
  breakpoint?: keyof Breakpoints;
}>`
  display: none;

  ${({ theme, breakpoint }) => theme.mediaBreakpointUp[breakpoint ?? 'md']} {
    display: flex;
    padding: ${({ theme }) => `${theme.spacing[8]} ${theme.spacing[12]}`};
    max-width: 233px;
  }
`;

export const Check = styled(CheckIcon)`
  margin-right: 10.5px;

  & path {
    fill: ${({ theme }) => theme.colors.highEmphasisWhite} !important;
  }
`;
